export const STATE_WAITING = 0
export const STATE_GRANTED = 1
export const STATE_DENIED = 2
